import { render } from "./RefList.vue?vue&type=template&id=595fb67e&scoped=true&ts=true"
import script from "./RefList.vue?vue&type=script&lang=ts"
export * from "./RefList.vue?vue&type=script&lang=ts"

import "./RefList.vue?vue&type=style&index=0&id=595fb67e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595fb67e"]])

export default __exports__